// routes
export const ROOT_ROUTE = '/';
export const CATEGORY_ROUTE = `${ROOT_ROUTE}categories/:categoryId`;
export const CHOICE_ROUTE = `${ROOT_ROUTE}choice/:choiceId`;
export const CATEGORY_SUBMIT_ROUTE = `${CATEGORY_ROUTE}/submit`;
export const THANKS_ROUTE = `${ROOT_ROUTE}thanks`;
export const CLOSED_VOTES_ROUTE = `${ROOT_ROUTE}closed`;
export const CATEGORY_SUBMIT_SUCCESS_ROUTE = `${CATEGORY_ROUTE}/submit-success`;

// actions:
export const INIT = {
	START: '--- INIT.START ---',
	SUCCESS: '--- INIT.SUCCESS ---',
	FAIL: '--- INIT.FAIL ---',
};
export const SET_POP_UP = 'SET_POP_UP';
export const SEND_EMAIL = 'SEND_EMAIL';
export const SEND_FORM = 'SEND_FORM';

export const SET_CATEGORY_SELECTION_START = 'SET_CATEGORY_SELECTION_START';
export const SET_CATEGORY_SELECTION_SUCCESS = 'SET_CATEGORY_SELECTION_SUCCESS';
export const SET_CATEGORY_SELECTION_FAIL = 'SET_CATEGORY_SELECTION_FAIL';

export const GET_CATEGORY_SELECTION_START = 'GET_CATEGORY_SELECTION_START';
export const GET_CATEGORY_SELECTION_SUCCESS = 'GET_CATEGORY_SELECTION_SUCCESS';
export const GET_CATEGORY_SELECTION_FAIL = 'GET_CATEGORY_SELECTION_FAIL';

export const SUBMIT_SELECTION_START = 'SUBMIT_SELECTION_START';
export const SUBMIT_SELECTION_SUCCESS = 'SUBMIT_SELECTION_SUCCESS';
export const SUBMIT_SELECTION_FAIL = 'SUBMIT_SELECTION_FAIL';

export const SUBMIT_INFO_START = 'SUBMIT_INFO_START';
export const SUBMIT_INFO_SUCCESS = 'SUBMIT_INFO_SUCCESS';
export const SUBMIT_INFO_FAIL = 'SUBMIT_INFO_FAIL';

export const RESET_ITEMS = 'RESET_ITEMS';

export const CHECK_AUTH_STATE_START = 'CHECK_AUTH_STATE_START';
export const CHECK_AUTH_STATE_SUCCESS = 'CHECK_AUTH_STATE_SUCCESS';
export const CHECK_AUTH_STATE_FAIL = 'CHECK_AUTH_STATE_FAIL';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';

export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

// pop-up
export const EMAIL_POP_UP = 'EMAIL_POP_UP';

// others:
export const IS_DEVEL = process.env.NODE_ENV === 'development';
export const IMAGES_PATH = 'assets/client/images';
export const USER_SELECTION_MAX_AMOUNT = 15;
export const USER_SELECTION_MIN_AMOUNT = 10;
export const LOCAL_STORAGE_PREF = '';

export const FAKE_TURNSTILE_TOKEN = 'dev-token-for-testing-only';

export const SHARE_CONSTANTS = {
	WHATSAPP: 'WhatsApp',
	TWITTER: 'Twitter',
	MAIL: 'Mail',
	FACEBOOK: 'Facebook',
};

export const APP_VIEWS = {
	INTRO: 'intro',
	MAIN: 'main',
	RESULTS: 'results',
};

export const MAKO_ANALYTICS_PAGE_IDS = {
	MAIN() {
		return 'HP';
	},
	CATEGORY(categoryId) {
		return `vote${categoryId}`;
	},
	SUBMIT(categoryId) {
		return `lastpage${categoryId}`;
	},
};

export const CATEGORY_TITLES = {
	אלבוםהשנה: {
		categoryTitle: 'הצביעו לאלבום השנה לשנת 2025 ',
		categoryTitleMobile: 'אלבום השנה לשנת 2025',
		enID: 'albums',
		nameHE: 'אלבומים',
	},
	זמרהשנה: {
		categoryTitle: 'הצביעו לאנשי השנה לשנת 2025 ',
		categoryTitleMobile: 'אנשי השנה לשנת 2025',
		enID: 'artists',
		nameHE: 'אנשים',
	},
	שירהשנה: {
		categoryTitle: 'הצביעו לשירי השנה שלכם/ן לשנת 2025',
		categoryTitleMobile: 'שיר השנה לשנת 2025',
		emID: 'songs',
		nameHE: 'שירים',
	},
	הופעתהשנה: {
		categoryTitle: 'הצביעו להופעת השנה שלכם/ן לשנת 2025',
		categoryTitleMobile: 'הופעת השנה לשנת 2025',
		emID: 'bestSong',
		nameHE: 'הופעות',
	},
	השירהגרוע: {
		categoryTitle: 'הצביעו לשיר הגרוע של השנה שלכם/ן לשנת 2025',
		categoryTitleMobile: 'השיר הגרוע לשנת 2025',
		emID: 'worstSong',
		nameHE: 'שירים',
	},
};
